// ===========================================================================
// Helpers de formatação da aba "Inserção manual" v2. Puros, sem React — fáceis
// de testar e reusar (CustomerLinkedBlock + ConfirmItemModal).
// ===========================================================================

/** Converte para número aceitando string ('-16.70') ou number. null se inválido. */
function toNumberOrNull(value) {
   if (value === null || value === undefined || value === '') return null;
   const n = Number(value);
   return Number.isNaN(n) ? null : n;
}

/** true se o endereço tem latitude E longitude numéricas. */
export function addressHasCoordinate(address) {
   if (!address) return false;
   return (
      toNumberOrNull(address.latitude) !== null &&
      toNumberOrNull(address.longitude) !== null
   );
}

/** "-16.7038, -49.2733" ou "—" quando faltar coordenada. */
export function formatCoordinate(address) {
   const lat = toNumberOrNull(address?.latitude);
   const lng = toNumberOrNull(address?.longitude);
   if (lat === null || lng === null) return '—';
   return `${lat.toFixed(4)}, ${lng.toFixed(4)}`;
}

/**
 * Linha de endereço apresentável a partir dos campos atomizados do cadastro.
 * Espelha o merge do import: "logradouro, número — cidade/UF".
 */
export function formatAddressLine(address) {
   if (!address) return '—';
   const street = (address.street || '').trim();
   const number = (address.number || '').toString().trim();
   const city = (address.city || '').trim();
   const state = (address.state || '').trim();

   let line = street;
   if (number) line += line ? `, ${number}` : number;
   if (city) line += line ? ` — ${city}` : city;
   if (state) {
      if (city) line += `/${state}`;
      else if (line) line += ` — ${state}`;
      else line = state;
   }

   return line || address.label || '—';
}

/**
 * Selo de geocodificação para o card de endereço.
 * Retorna { tone: 'ok' | 'warn', label } ou null quando não há nada a sinalizar.
 */
export function geocodeBadgeForAddress(address) {
   if (!address) return null;
   const status = String(address.geocode_status || '').toLowerCase();

   if (!addressHasCoordinate(address)) {
      return { tone: 'warn', label: 'sem coordenada' };
   }
   if (status === 'pending') return { tone: 'warn', label: 'geo pendente' };
   if (status === 'failed') return { tone: 'warn', label: 'geo falhou' };
   if (status === 'ok') return { tone: 'ok', label: 'geocodificado' };
   // Tem coordenada e status desconhecido/ausente → considera ok.
   return { tone: 'ok', label: 'geocodificado' };
}

/** "2026-06-30" → "30/06/2026". null/'' → "—". */
export function formatDateBR(iso) {
   if (!iso) return '—';
   const parts = String(iso).split('-');
   if (parts.length !== 3) return iso;
   const [y, m, d] = parts;
   return `${d}/${m}/${y}`;
}

/**
 * Extrai valor numérico da string formatada do CurrencyInput.
 * "R$ 1.250,00" → 1250.00 / "" → null (campo vazio omite do payload).
 */
export function extractNumericValueFromCurrencyString(currencyString) {
   if (!currencyString) return null;
   const numericString = String(currencyString)
      .replace(/[R$\s.]/g, '')
      .replace(',', '.');
   const parsed = parseFloat(numericString);
   return Number.isNaN(parsed) ? null : parsed;
}
